export const companySlug = (name) =>
  String(name).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

export const sum = (arr) => (arr || []).reduce((a, b) => a + b, 0);

export const fmtWk = (s) => {
  const d = new Date(s + 'T00:00:00Z');
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()}`;
};

export const PALETTE = [
  '#5b8def', '#37c98b', '#f5a623', '#e9576b', '#a06bf2', '#46c6d6',
  '#d98b3a', '#7f8da3', '#c45ec4', '#6fae5a', '#df6f9a', '#5aa0b8', '#b0823a', '#5fae8a',
];
export const AREA_COLOR = '#5b8def';
export const USE_COLOR = '#37c98b';
export const NEW_COLOR = '#f5a623';
